var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"small"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.description))]),_c('ul',_vm._l((_vm.recoveryPasswordDetails),function(detail,index){return _c('li',{key:`password-description-${index}`},[_vm._v(" "+_vm._s(detail)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }